<template>
  <div class="card card-with-image is-small-padding my-2 my-4-sm my-3-ms">
    <img
      class="card-image mr-3"
      :src="adviser.image_url"
      :alt="$t('adviserSettings.photoExpert') + adviser.name + ' ' + adviser.surname">
    <div class="card-content">
      <div
        v-if="adviser.promoted"
        class="adviser-promoted">
        {{ $t('ui.featured') }}
      </div>
      <div class="card-body flex">
        <div
          :class="{
            'adviser-content mr-auto': true,
            'is-promoted': adviser.promoted
          }">
          <h2
          :class="{
            'heading-small text-grey mr-auto': true,
            'adviser-online': adviser.is_online
          }">
            <a :href="adviser.front_url">{{ adviser.name }} {{ adviser.surname }}</a>
          </h2>
          <div class="flex flex-align-items-center rating-wrapper">
            <div
              v-for="(index) of 5"
              :key="'note-' + index"
              :class="{
                'star-wrapper small': true,
                'is-selected': adviser.opinions_avg_note >= index
              }">
              <f-icon
                name="star"
                class="rating-star my-auto" />
            </div>
            <span class="small ml-1">{{ $tc('opinion.opinionForCounter', adviser.opinions_count)}}</span>
          </div>
          <div class="mt-1">
            {{ adviser.description }}
          </div>
        </div>

        <div class="adviser-buttons flex flex-column no-shrink ml-3 flex-row-mxs">
          <a
            :href="adviser.front_url"
            target="_blank"
            rel="nofollow noopener noreferrer"
            class="f-btn f-btn-primary-outline mb-1 mb-3-xs">
            {{ $t('dashboard.checkTheProfile') }}
          </a>
          <a
            :href="adviser.front_url_consultation"
            target="_blank"
            rel="nofollow noopener noreferrer"
            class="f-btn f-btn-primary">
            {{ $t('dashboard.orderConsultation') }}
          </a>

        </div>
      </div>
      <div class="card-footer">
        <a
          v-if="adviser.city"
          href="#"
          class="lnk lnk-contact mr-3 mt-1 mt-2-sm full-width-sm mr-0-sm">
          <f-icon name="map-pin" />
          {{ adviser.city }}
        </a>
        <a
          v-if="adviser.phone"
          :href="'tel:' + removeSpacesFromString(adviser.phone)"
          class="lnk lnk-contact mr-3 mt-1 mt-2-sm full-width-sm mr-0-sm">
          <f-icon name="phone" />
          {{ adviser.phone }}
        </a>
        <a
          v-if="adviser.email"
          :href="'mailto:' + adviser.email"
          class="lnk lnk-contact mt-1 mt-2-sm full-width-sm">
          <f-icon name="mail" />
          {{ adviser.email }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'f-adviser',
  props: {
    adviser: {
      type: Object,
      required: true
    }
  },
  methods: {
    removeSpacesFromString (str) {
      if (!str) {
        return '';
      }

      return str.replace(/\s/g, '');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.adviser-promoted {
  background: $color-secondary;
  border-radius: 0 0 3px 3px;
  color: $color-light;
  font-size: var(--font-size-tiny);
  font-weight: 600;
  line-height: $font-line-height-tiny;
  padding: 5px 10px;
  position: absolute;
  text-transform: uppercase;
  top: -25px;
  width: auto;
}

.adviser-content .adviser-online a {
  padding-right: 21px;
  position: relative;

  &:after {
    background: $color-green;
    border-radius: 50%;
    content: "";
    height: 13px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(calc(-50% - 1px));
    width: 13px;
  }
}

.adviser-content.is-promoted {
  margin-top: 6px;
}

@media screen and (max-width: $media-tablet-l) {
  .adviser-promoted {
    top: -20px;
  }
}

@media screen and (max-width: $media-tablet-xs) {
  .adviser-buttons {
    align-items: unset;
    flex-direction: row!important;
    justify-content: space-between;
    margin-left: 0!important;
    margin-top: 3rem;

    .f-btn {
      width: 48%;
    }
  }

  .adviser-promoted {
    border-radius: 2px 10px 2px 2px;
    left: unset;
    right: 0;
    top: 0;
  }
}

@media screen and (max-width: $media-phone-s) {
  .adviser-buttons {
    flex-wrap: wrap;
    margin-top: 4rem;

    .f-btn {
      width: 100%;
    }
  }
}

</style>
